// Lib
import { serviceCaseTypes, getHandlingLocation } from '@/lib/serviceCaseStatuses'
import dayjs from '@/lib/dayjs'

// Icons
import { Star01 } from '@untitled-ui/icons-react'

// Router
import { Link } from 'react-router-dom'

export default function ServiceCaseKanbanItem({
    item,
    linkUrl = '/service-cases',
    onOpen,
}) {
    const serviceCase = item

    // Get type label and icon
    const typeConfig = serviceCaseTypes[serviceCase?.type] || {
        label: serviceCase?.type,
    }
    const TypeIcon = typeConfig.icon

    // Get time since last status change
    const currentStatusAtHuman = dayjs().to(dayjs(serviceCase?.current_status_at), true)

    const handleItemClick = (e) => {
        const isNewTabClick = e.ctrlKey || e.metaKey || e.button === 1

        if (isNewTabClick) {
            return
        }

        onOpen?.(serviceCase.id)
        e.preventDefault()
    }

    return (
        <Link
            key={serviceCase?.id}
            className="border p-5 rounded-xl bg-white hover:bg-gray-50 cursor-pointer select-none flex flex-col gap-2"
            to={`${linkUrl}/${serviceCase?.id}`}
            onClick={handleItemClick}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-1">
                    {serviceCase.is_priority === true && (
                        <Star01
                            className="text-red-500 fill-red-500"
                            width={16}
                            height={16}
                        />
                    )}

                    <span className="font-medium font-mono">
                        {serviceCase.display_name}
                    </span>
                    {Number(serviceCase.is_archived) === 1 && (
                        <span className="px-1.5 py-0.5 text-xs rounded-sm bg-gray-200 text-gray-500">
                            Archivé
                        </span>
                    )}
                </div>

                <span className="text-sm text-gray-500 flex items-center gap-1">
                    {TypeIcon && <TypeIcon width={14} height={14} />}
                    {typeConfig.label}
                </span>
            </div>

            <div className="flex flex-col">
                <span className="text-gray-700">
                    {serviceCase?.customer_name || 'Client inconnu'}
                </span>

                <span className="text-sm text-gray-500 truncate">
                    {serviceCase?.product_name ||
                        'Produit non renseigné'}
                </span>
            </div>

            {serviceCase?.is_handled_by && (
                <span className="text-sm text-gray-500">
                    Traitement : {getHandlingLocation(serviceCase.is_handled_by).label}
                </span>
            )}

            <span className="text-gray-400 text-sm mt-1">
                Depuis {currentStatusAtHuman}
            </span>

            {serviceCase?.service_reasons?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                    {serviceCase.service_reasons.map((reason) => (
                        <span
                            key={reason.id}
                            className="px-2 py-0.5 text-xs rounded-sm bg-gray-100 text-gray-600"
                        >
                            {reason.name}
                        </span>
                    ))}
                </div>
            )}

        </Link>
    )
}
